import { render, staticRenderFns } from "./OctSwitch.vue?vue&type=template&id=7339d46e&scoped=true&"
import script from "./OctSwitch.vue?vue&type=script&lang=js&"
export * from "./OctSwitch.vue?vue&type=script&lang=js&"
import style0 from "./OctSwitch.vue?vue&type=style&index=0&id=7339d46e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7339d46e",
  null
  
)

export default component.exports